import { render, staticRenderFns } from "./canal-code.vue?vue&type=template&id=1cf9bf48&scoped=true"
import script from "./canal-code.vue?vue&type=script&lang=js"
export * from "./canal-code.vue?vue&type=script&lang=js"
import style0 from "./canal-code.vue?vue&type=style&index=0&id=1cf9bf48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf9bf48",
  null
  
)

export default component.exports